<div class="toast-container topcenter">
  <ngb-toast
    *ngFor="let toast of toastService.toasts.topcenter"
    [class]="toast.type"
    class="mt-2"
    [autohide]="toast.isAutoHiding"
    [delay]="toast.delay || 2500" (hidden)="toastService.remove(toast)">
    <span class="p-2">
      {{ toast.content }}
    </span>

    <span class="loader" *ngIf="toast.type == 'loading'">
      <app-svg class="rotating" source="icons/feather/loader" height="18"></app-svg>
    </span>

    <a class="clicker" *ngIf="toast.type == 'asking'" (click)="hidePrevious()">
      <app-svg source="icons/feather/check" height="18"></app-svg>
    </a>

    <a class="clicker" *ngIf="toast.type == 'note' || toast.type == 'asking'" (click)="clear()">
      <app-svg source="icons/feather/x" height="18"></app-svg>
    </a>
  </ngb-toast>
</div>

<div class="toast-container bottomright">
  <ngb-toast
    *ngFor="let toast of toastService.toasts.bottomright"
    [class]="toast.type"
    [autohide]="toast.isAutoHiding"
    [delay]="toast.delay || 2500" (hidden)="toastService.remove(toast)">
    <span class="message">
      {{ toast.content }}
    </span>

    <span class="loader" *ngIf="toast.type == 'loading'">
      <app-svg class="rotating" source="icons/feather/loader" height="18"></app-svg>
    </span>

    <a class="clicker" *ngIf="toast.type == 'asking'" (click)="hidePrevious()">
      <app-svg source="icons/feather/check" height="18"></app-svg>
    </a>

    <a class="clicker" *ngIf="toast.type == 'note' || toast.type == 'asking'" (click)="clear('bottomright')">
      <app-svg source="icons/feather/x" height="18"></app-svg>
    </a>
  </ngb-toast>
</div>
